import {
  DEFAULT_ACTIONS_COLUMN_WIDTH,
  TABLE_ACTIONS_INLINE_EXTRA_PER_ACTION_PX,
} from '@/utils/constants';
import { isMobileOnly } from 'react-device-detect';

export const TABLE_ACTIONS_COLUMN_CLASS_NAME = 'ant-table-cell-actions';

/**
 * @param {object} opts
 * @param {number | null | undefined} opts.width — explícito; si viene definido, gana.
 * @param {boolean} [opts.isMobileView] — si no se pasa, usa `isMobileOnly`.
 * @param {boolean} [opts.alwaysDropdown=false] — siempre menú / tres puntos en desktop.
 * @param {number} [opts.inlineActionCount=3] — acciones en fila en desktop; `0` fuerza ancho mínimo (base).
 */
export function resolveTableActionsColumnWidth({
  width: explicitWidth,
  isMobileView = isMobileOnly,
  alwaysDropdown = false,
  inlineActionCount = 3,
} = {}) {
  if (explicitWidth !== undefined && explicitWidth !== null) {
    return explicitWidth;
  }
  if (isMobileView || alwaysDropdown) {
    return DEFAULT_ACTIONS_COLUMN_WIDTH;
  }
  const n = Math.max(0, Number(inlineActionCount) || 0);
  if (n <= 1) {
    return DEFAULT_ACTIONS_COLUMN_WIDTH;
  }
  return DEFAULT_ACTIONS_COLUMN_WIDTH + TABLE_ACTIONS_INLINE_EXTRA_PER_ACTION_PX * (n - 1);
}

/**
 * Columna de acciones estándar (Ant Design).
 * Con constantes actuales (60 base, +20 por acción extra):
 * - 0 o 1 acción inline -> 60
 * - 2 acciones inline -> 80
 * - 3 acciones inline -> 100
 * Móvil o `alwaysDropdown` -> ancho base.
 * Pasá `width` para forzar cualquier valor.
 */
export function createTableActionsColumn({
  render,
  width: widthProp,
  alwaysDropdown = false,
  inlineActionCount = 3,
  isMobileView: isMobileViewProp,
  align = 'center',
  fixed = 'right',
  title = '',
  className = TABLE_ACTIONS_COLUMN_CLASS_NAME,
  omitWidth = false,
  ...rest
}) {
  const resolvedWidth = resolveTableActionsColumnWidth({
    width: widthProp,
    isMobileView: isMobileViewProp ?? isMobileOnly,
    alwaysDropdown,
    inlineActionCount,
  });

  return {
    ...rest,
    title,
    className,
    align,
    fixed,
    ...(!omitWidth ? { width: resolvedWidth } : {}),
    render,
  };
}
